import React from 'react';
import { Flex, HStack } from '@chakra-ui/react';

// item 577 — THE shared form-footer action bar (the doc forms via DocumentFormScaffold
// plus the standalone entity forms). Replaces the old flat wrapping row, which at
// sub-wide widths wrapped arbitrarily (Save orphaned under Approve, the save-status
// badge jammed against Cancel). Three semantic clusters instead:
//   1. `primary`  — the document's status verbs (Approve/Decline, Finalize…). Renders
//      FIRST and stays prominent; the cluster never breaks internally.
//   2. `utilities` — secondary tools (View PDF · Send · Sales tracking …). They wrap
//      AS A GROUP: one flex item that drops below the primary verbs as a block and
//      wraps within itself, never interleaving with the other clusters.
//   3. `save` — the save-status badge + Cancel + Save. Anchored together on the right
//      (ml="auto" keeps it right-aligned even when it wraps onto its own row) and the
//      three pieces never separate — the badge text wraps within itself instead
//      (minW=0; the buttons keep their nowrap min-content width).
// Plain border-top + standard buttons — no aurora decoration, so Basix Aurora and
// Accountant both render it correctly as-is.
interface FormActionBarProps {
  primary?: React.ReactNode;
  utilities?: React.ReactNode;
  save: React.ReactNode;
}

const FormActionBar: React.FC<FormActionBarProps> = ({ primary, utilities, save }) => (
  <Flex mt={4} pt={4} borderTopWidth="1px" align="center" flexWrap="wrap" gap={3}>
    {primary && (
      <HStack spacing={2} flexShrink={0}>
        {primary}
      </HStack>
    )}
    {utilities && (
      <Flex align="center" flexWrap="wrap" gap={1} minW={0}>
        {utilities}
      </Flex>
    )}
    <HStack spacing={2} ml="auto" minW={0} justify="flex-end">
      {save}
    </HStack>
  </Flex>
);

FormActionBar.defaultProps = {
  primary: undefined,
  utilities: undefined,
};

export default FormActionBar;
